<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="12"
        :form-context="formContext"
        icon="inticon-users"
        title="Mietwagenunternehmen"
        @save="saveCarRentalCompanyFormData">
        <b-row>
            <csp-desktop-info-card-element
                class="col-12"
                :form-context="formContext"
                label="Mietwagenunternehmen"
                :options-loader="loadCarRentalCompanyOptions"
                property="carRentalCompany"
                type="autocomplete">
                <template v-slot:display-value>
                    <p>
                        <span v-if="firmData.name"><b>{{ firmData.name }}</b><br></span>
                        <span v-if="firmData.street">{{ firmData.street }}<br></span>
                        <span v-if="firmData.postalCode || firmData.city">
                            {{ firmData.postalCode }} {{ firmData.city }}<br>
                        </span>
                        <span v-if="firmData.countryName">{{ firmData.countryName }}<br></span>
                    </p>
                    <p>
                        <span v-if="firmData.phone">{{ firmData.phone }}<br></span>
                        <span v-if="firmData.email">
                            <a :href="'mailto:' + firmData.email">{{ firmData.email }}</a>
                        </span>
                    </p>
                </template>
            </csp-desktop-info-card-element>
        </b-row>
    </csp-desktop-info-card>
</template>

<script>
    import FormDataMixin from '../../mixins/FormDataMixin';
    import Container from '@services/Container';

    const container = Container.getInstance();
    const recordRepository = container.getDesktopRecordRepository();

    export default {
        name: 'ParticipantCarRentalCompany',
        mixins: [FormDataMixin],
        computed: {
            recordId() {
                return parseInt(this.$route.params.recordId);
            },
            firmData() {
                return {
                    'name': this.formContext.form.getProperty('firmName') ?? '',
                    'street': this.formContext.form.getProperty('firmStreet') ?? '',
                    'postalCode': this.formContext.form.getProperty('firmPostalCode') ?? '',
                    'city': this.formContext.form.getProperty('firmCity') ?? '',
                    'countryName': this.formContext.form.getProperty('firmCountryName') ?? '',
                    'phone': this.formContext.form.getProperty('firmPhone') ?? '',
                    'email': this.formContext.form.getProperty('firmEmail') ?? '',
                };
            },
        },
        methods: {
            loadCarRentalCompanyOptions() {
                return recordRepository.loadCarRentalCompanyFirmOptions(this.recordId);
            },
            saveCarRentalCompanyFormData(formContext) {
                const saveFunction = (objectId, postData) => {
                    return recordRepository.saveParticipantsCarRentalCompany(this.recordId, postData)
                }
                this.saveFormData(formContext, saveFunction, null);
            },
        },
    }
</script>
